import { render } from "./SeparatorSection.vue?vue&type=template&id=e912e520&scoped=true"
import script from "./SeparatorSection.vue?vue&type=script&lang=js"
export * from "./SeparatorSection.vue?vue&type=script&lang=js"

import "./SeparatorSection.vue?vue&type=style&index=0&id=e912e520&scoped=true&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e912e520"]])

export default __exports__